const ProjectRoles = {
  PROJECT_ADMIN: "Project Admin",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_EDITOR: "Project Editor",
  PROJECT_MEMBER: "Project Member",
  PROJECT_GUEST: "Project Guest"
};

export default ProjectRoles;
